<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
            <i class="fa fa-calendar-check-o text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Validade de Lotes</h4>
            <small class="text-muted mb-0 d-none d-lg-block">Gestão Consolidada de Vencimentos</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
          <!-- Botões de Exportação -->
          <b-button-group class="mr-2 d-none d-lg-inline-flex bg-light rounded-pill p-1 shadow-xs border">
            <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
              <i class="fa fa-file-excel-o"></i>
            </b-button>
            <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
              <i class="fa fa-file-text-o"></i>
            </b-button>
            <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
              <i class="fa fa-print"></i>
            </b-button>
          </b-button-group>

          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
            <div class="d-flex align-items-center px-2 border-right mr-2">
              <b-form-select 
                v-model="filtro.centroEstoqueId" 
                class="bg-transparent border-0" 
                :style="{ width: '180px', fontSize: '0.9rem' }" 
                :options="centroEstoqueOptions">
                <template slot="first">
                  <option :value="null">Todos os Centros</option>
                </template>
              </b-form-select>
            </div>
            <div class="d-flex align-items-center px-2 mr-2">
              <b-form-select 
                v-model="filtro.status" 
                class="bg-transparent border-0" 
                :style="{ width: '140px', fontSize: '0.9rem' }" 
                :options="statusOptions">
              </b-form-select>
            </div>
            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="carregarDados()">
              <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Resumo Analítico -->
      <b-row class="mb-4 px-3">
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden h-100">
            <div class="card-body p-3 d-flex align-items-center">
              <div class="bg-primary-soft p-3 rounded-circle mr-3">
                <i class="fa fa-cubes text-primary fa-lg"></i>
              </div>
              <div>
                <h6 class="text-muted mb-0 small">Total Lotes</h6>
                <h3 class="font-weight-bold mb-0">{{ resumo.total }}</h3>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden h-100 bg-danger text-white">
            <div class="card-body p-3 d-flex align-items-center">
              <div class="bg-white-10 p-3 rounded-circle mr-3">
                <i class="fa fa-warning text-white fa-lg"></i>
              </div>
              <div>
                <h6 class="text-white-50 mb-0 small">Vencidos</h6>
                <h3 class="font-weight-bold mb-0">{{ resumo.vencidos }}</h3>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden h-100 bg-warning">
            <div class="card-body p-3 d-flex align-items-center">
              <div class="bg-black-10 p-3 rounded-circle mr-3">
                <i class="fa fa-clock-o text-dark fa-lg"></i>
              </div>
              <div>
                <h6 class="text-dark-50 mb-0 small">Em Alerta</h6>
                <h3 class="font-weight-bold mb-0 text-dark">{{ resumo.alerta }}</h3>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden h-100 bg-success text-white">
            <div class="card-body p-3 d-flex align-items-center">
              <div class="bg-white-10 p-3 rounded-circle mr-3">
                <i class="fa fa-check-circle text-white fa-lg"></i>
              </div>
              <div>
                <h6 class="text-white-50 mb-0 small">Regulares</h6>
                <h3 class="font-weight-bold mb-0">{{ resumo.ok }}</h3>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Gráfico e Tabela -->
      <b-row class="px-3">
        <!-- Gráfico Lateral -->
        <b-col lg="3" class="mb-4">
          <div class="card border-0 shadow-sm h-100 p-3">
            <h6 class="font-weight-bold mb-4">Distribuição de Status</h6>
            <div class="chart-container d-flex flex-column align-items-center justify-content-center" style="height: 250px;">
              <template v-if="resumo.total > 0">
                <v-chart class="chart w-100" :option="chartOption" autoresize />
              </template>
              <div v-else class="text-muted text-center py-5">
                <i class="fa fa-pie-chart fa-3x mb-2 opacity-2"></i>
                <p>Sem dados para exibir</p>
              </div>
            </div>
            <div class="legend mt-3">
              <div class="d-flex align-items-center mb-2">
                <span class="dot bg-danger mr-2"></span>
                <small class="flex-grow-1">Vencidos</small>
                <small class="font-weight-bold">{{ percVencidos }}%</small>
              </div>
              <div class="d-flex align-items-center mb-2">
                <span class="dot bg-warning mr-2"></span>
                <small class="flex-grow-1">Em Alerta</small>
                <small class="font-weight-bold">{{ percAlerta }}%</small>
              </div>
              <div class="d-flex align-items-center">
                <span class="dot bg-success mr-2"></span>
                <small class="flex-grow-1">Regulares</small>
                <small class="font-weight-bold">{{ percOk }}%</small>
              </div>
            </div>
          </div>
        </b-col>

        <!-- Listagem de Lotes -->
        <b-col lg="9" class="mb-4">
          <div class="table-card-container">
            <b-table 
              class="modern-premium-table table-card-rows"
              :busy.sync="isBusy" 
              :items="lotes" 
              :fields="fields"
              :tbody-tr-class="rowClass"
              hover 
              small 
              show-empty
              empty-text="Nenhum lote com saldo encontrado nos filtros selecionados"
              responsive
            >
              <template #cell(DIAS_PARA_VENCER)="data">
                <div class="d-flex align-items-center justify-content-center">
                  <b-badge :variant="statusBadgeVariant(data.item.STATUS_VALIDADE)" pill class="px-2 py-1">
                    {{ data.value }} dias
                  </b-badge>
                  <i v-if="data.item.STATUS_VALIDADE === 'VENCIDO'" class="fa fa-warning text-danger ml-2 animated infinite pulse"></i>
                </div>
              </template>

              <template #cell(DATA_VALIDADE)="data">
                {{ formatarData(data.value) }}
              </template>

              <template #cell(QUANT_SALDO)="data">
                <span class="font-weight-bold text-dark">{{ data.value.toFixed(2) }}</span>
              </template>
              
              <template #cell(STATUS_VALIDADE)="data">
                <div class="d-flex align-items-center">
                  <div :class="'status-indicator bg-' + statusColor(data.value) + ' mr-2'"></div>
                  <span :class="'text-' + statusColor(data.value) + ' font-weight-bold'">{{ data.value }}</span>
                </div>
              </template>

              <template #cell(actions)="row">
                <div class="d-flex justify-content-center gap-1">
                  <b-button variant="soft-secondary" pill class="btn-icon-only shadow-sm" @click.stop.prevent="imprimirEspelhoLote(row.item)" v-b-tooltip.hover title="Ver Espelho (A4)">
                    <i class="fa fa-file-text-o"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { printHtmlReport, exportExcelXlsx, exportCsv } from '@/utils/RelatorioHTML'

function escapeHtml(valor) {
  return String(valor == null ? '' : valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function formatarDataHoraRelatorio() {
  return new Date().toLocaleString('pt-BR')
}

export default {
  name: 'EstoqueValidadeLotes',
  data() {
    return {
      isBusy: false,
      filtro: {
        centroEstoqueId: null,
        status: 'TODOS'
      },
      lotes: [],
      centroEstoqueOptions: [],
      statusOptions: [
        { value: 'TODOS', text: 'Todos os Status' },
        { value: 'VENCIDO', text: 'Vencidos' },
        { value: 'ALERTA', text: 'Em Alerta (30 dias)' },
        { value: 'OK', text: 'Regulares' }
      ],
      fields: [
        { key: 'DESCRICAO_PRODUTO', label: 'Produto', sortable: true },
        { key: 'LOTE', label: 'Lote', sortable: true },
        { key: 'DESCRICAO_CENTRO', label: 'Centro Estoque', sortable: true },
        { key: 'DATA_VALIDADE', label: 'Validade', sortable: true, class: 'text-center' },
        { key: 'QUANT_SALDO', label: 'Saldo', sortable: true, class: 'text-right' },
        { key: 'DIAS_PARA_VENCER', label: 'Restante', sortable: true, class: 'text-center' },
        { key: 'STATUS_VALIDADE', label: 'Situação', sortable: true },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '80px' } }
      ],
      resumo: {
        total: 0,
        vencidos: 0,
        alerta: 0,
        ok: 0
      }
    }
  },
  computed: {
    isDark() {
      return this.$store.state.theme === 'dark'
    },
    percVencidos() {
      return this.resumo.total > 0 ? ((this.resumo.vencidos / this.resumo.total) * 100).toFixed(0) : 0
    },
    percAlerta() {
      return this.resumo.total > 0 ? ((this.resumo.alerta / this.resumo.total) * 100).toFixed(0) : 0
    },
    percOk() {
      return this.resumo.total > 0 ? ((this.resumo.ok / this.resumo.total) * 100).toFixed(0) : 0
    },
    chartOption() {
      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [
          {
            name: 'Status Validade',
            type: 'pie',
            radius: ['50%', '80%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: this.resumo.vencidos, name: 'Vencidos', itemStyle: { color: '#e55353' } },
              { value: this.resumo.alerta, name: 'Em Alerta', itemStyle: { color: '#f9b115' } },
              { value: this.resumo.ok, name: 'Regulares', itemStyle: { color: '#2eb85c' } }
            ]
          }
        ]
      }
    }
  },
  mounted() {
    this.carregarCentros()
    this.carregarDados()
  },
  methods: {
    carregarCentros() {
      axios.get('/api/protected/centroEstoque/getAtivos').then(res => {
        this.centroEstoqueOptions = res.data.map(c => ({ value: c.CODIGO, text: c.DESCRICAO }))
      })
    },
    carregarDados() {
      this.isBusy = true
      axios.get('/api/protected/estoque/getRelatorioValidadeLotes', { params: this.filtro })
        .then(res => {
          this.lotes = res.data
          this.calcularResumo(res.data)
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    calcularResumo(dados) {
      this.resumo.total = dados.length
      this.resumo.vencidos = dados.filter(d => d.STATUS_VALIDADE === 'VENCIDO').length
      this.resumo.alerta = dados.filter(d => d.STATUS_VALIDADE === 'ALERTA').length
      this.resumo.ok = dados.filter(d => d.STATUS_VALIDADE === 'OK').length
    },
    formatarData(data) {
      return data ? moment(data).format('DD/MM/YYYY') : '-'
    },
    formatarNumero(valor, casas = 2) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })
    },
    statusBadgeVariant(status) {
      if (status === 'VENCIDO') return 'danger'
      if (status === 'ALERTA') return 'warning'
      return 'success'
    },
    statusColor(status) {
      if (status === 'VENCIDO') return 'danger'
      if (status === 'ALERTA') return 'warning'
      return 'success'
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.STATUS_VALIDADE === 'VENCIDO') return 'bg-danger-soft-row'
      if (item.STATUS_VALIDADE === 'ALERTA') return 'bg-warning-soft-row'
    },
    exportarHtml() {
      this.imprimirListagemCustomizada();
    },
    async imprimirListagemCustomizada() {
      const janela = window.open('', '_blank')
      if (!janela) {
        this.$bvToast.toast('Navegador bloqueou a abertura do relatório.', { title: 'Aviso', variant: 'warning', solid: true })
        return
      }

      try {
        const empresa = await this.obterEmpresaPreferencial()
        const html = this.montarHtmlListagemCustomizada(empresa)
        janela.document.open('text/html', 'replace')
        janela.document.write(html)
        janela.document.close()
        janela.focus()
      } catch (err) {
        janela.close()
        console.error(err)
      }
    },
    montarHtmlListagemCustomizada(empresa) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      const colunas = this.fields.filter(f => f.key !== 'actions')
      
      const thead = `
        <thead>
          <tr>
            ${colunas.map(c => `<th style="text-align:${c.class?.includes('text-right') ? 'right' : (c.class?.includes('text-center') ? 'center' : 'left')};">${c.label}</th>`).join('')}
          </tr>
        </thead>`

      const tbody = `
        <tbody>
          ${this.lotes.map(item => `
            <tr style="background: ${item.STATUS_VALIDADE === 'VENCIDO' ? '#fff5f5' : (item.STATUS_VALIDADE === 'ALERTA' ? '#fffaf0' : 'transparent')}">
              <td>${escapeHtml(item.DESCRICAO_PRODUTO)}</td>
              <td>${escapeHtml(item.LOTE)}</td>
              <td>${escapeHtml(item.DESCRICAO_CENTRO)}</td>
              <td style="text-align:center;">${escapeHtml(this.formatarData(item.DATA_VALIDADE))}</td>
              <td style="text-align:right;">${escapeHtml(this.formatarNumero(item.QUANT_SALDO, 2))}</td>
              <td style="text-align:center;">${escapeHtml(item.DIAS_PARA_VENCER)}</td>
              <td style="color:${this.statusColor(item.STATUS_VALIDADE) === 'danger' ? '#e53e3e' : (this.statusColor(item.STATUS_VALIDADE) === 'warning' ? '#dd6b20' : '#38a169')}; font-weight:bold;">
                ${escapeHtml(item.STATUS_VALIDADE)}
              </td>
            </tr>
          `).join('')}
        </tbody>`

      return `<!doctype html>
      <html lang="pt-BR">
      <head>
        <meta charset="utf-8">
        <title>Relatório de Validade de Lotes</title>
        <style>
          body { font-family: Arial, Helvetica, sans-serif; margin: 16px; color: #111; padding-bottom: 80px; }
          .report-header { border: 1px solid #2f2f2f; margin-bottom: 20px; }
          .report-header-top, .report-header-sub { display: flex; justify-content: space-between; padding: 4px 8px; font-size: 11px; border-bottom: 1px solid #2f2f2f; }
          .report-header-title { padding: 8px; font-size: 14px; font-weight: 700; text-transform: uppercase; background: #f2f2f2; text-align: center; }
          .grid { width: 100%; border-collapse: collapse; margin-top: 10px; }
          .grid th, .grid td { border: 1px solid #ccc; padding: 6px 8px; font-size: 10px; }
          .grid th { background: #f8f9fa; font-weight: bold; text-transform: uppercase; }
          .footer-signatures { position: fixed; bottom: 30px; left: 16px; right: 16px; display: flex; justify-content: space-around; background: #fff; padding-top: 10px; }
          .signature-box { border-top: 1px solid #2f2f2f; width: 250px; padding-top: 5px; font-size: 10px; text-align: center; }
          .page-info { position: fixed; bottom: 5px; left: 16px; right: 16px; display: flex; justify-content: space-between; font-size: 9px; color: #666; border-top: 1px solid #eee; padding-top: 3px; }
          @media print { 
            @page { size: A4 landscape; margin: 10mm; } 
            body { margin: 0; padding-bottom: 100px; }
            .grid { page-break-inside: auto; }
            tr { page-break-inside: avoid; page-break-after: auto; }
          }
        </style>
      </head>
      <body>
        <div class="report-header">
          <div class="report-header-top">
            <div><strong>${escapeHtml(empresa.FANTASIA || empresa.RAZAO_RELATORIO || empresa.RAZAO || 'CECWEB')}</strong></div>
            <div><strong>Filtro:</strong> ${escapeHtml(this.filtro.status)} | <strong>Centro:</strong> ${escapeHtml(this.filtro.centroEstoqueId || 'Todos')}</div>
          </div>
          <div class="report-header-title">Listagem Consolidada de Validade de Lotes</div>
          <div class="report-header-sub">
            <div>${escapeHtml(empresa.NOME_EMPRESA || '')}</div>
            <div><strong>Emitido em:</strong> ${escapeHtml(formatarDataHoraRelatorio())} - <strong>Usuário:</strong> ${escapeHtml(nomeUsuario)}</div>
          </div>
        </div>

        <table class="grid">
          ${thead}
          ${tbody}
        </table>

        <div class="footer-signatures">
          <div class="signature-box">Conferido por (Estoque)</div>
          <div class="signature-box">Visto da Supervisão</div>
          <div class="signature-box">Controle de Qualidade</div>
        </div>

        <div class="page-info">
          <div>Relatório de Validade de Lotes - CECWEB</div>
          <div>Impresso em: ${escapeHtml(formatarDataHoraRelatorio())}</div>
        </div>
      </body>
      </html>`
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.lotes,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'validade_lotes.xls'
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.lotes,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'validade_lotes.csv',
      });
    },
    async obterEmpresaPreferencial() {
      const { data } = await axios.get('/api/protected/conferenciaFinanceira/empresa-preferencial')
      return data || {}
    },
    async imprimirEspelhoLote(lote) {
      const janela = window.open('', '_blank')
      if (!janela) {
        this.$bvToast.toast('Navegador bloqueou a abertura do espelho.', { title: 'Aviso', variant: 'warning', solid: true })
        return
      }

      try {
        const empresa = await this.obterEmpresaPreferencial()
        const html = this.montarHtmlEspelhoLote(lote, empresa)
        janela.document.open('text/html', 'replace')
        janela.document.write(html)
        janela.document.close()
        janela.focus()
      } catch (err) {
        janela.close()
        console.error(err)
      }
    },
    montarHtmlEspelhoLote(lote, empresa) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      
      return `<!doctype html>
      <html lang="pt-BR">
      <head>
        <meta charset="utf-8">
        <title>Espelho de Lote - ${lote.LOTE}</title>
        <style>
          body { font-family: Arial, Helvetica, sans-serif; margin: 16px; color: #111; }
          .report-header { border: 1px solid #2f2f2f; }
          .report-header-top, .report-header-sub { display: flex; justify-content: space-between; padding: 4px 8px; font-size: 11px; border-bottom: 1px solid #2f2f2f; }
          .report-header-title { padding: 4px 8px; font-size: 14px; font-weight: 700; text-transform: uppercase; background: #f2f2f2; }
          .section { margin-top: 20px; }
          .section-title { font-size: 12px; font-weight: 700; margin-bottom: 8px; text-transform: uppercase; border-bottom: 1px solid #eee; padding-bottom: 4px; }
          .info-table { width: 100%; border-collapse: collapse; }
          .info-table td { border: 1px solid #eee; padding: 10px 12px; font-size: 12px; vertical-align: top; width: 50%; }
          .val-label { font-weight: bold; color: #666; display: block; margin-bottom: 4px; font-size: 10px; text-transform: uppercase; }
          .val-content { font-size: 14px; font-weight: bold; }
          .status-badge { display: inline-block; padding: 4px 12px; border-radius: 20px; font-weight: bold; color: #fff; }
          .bg-danger { background-color: #e55353; }
          .bg-warning { background-color: #f9b115; color: #000; }
          .bg-success { background-color: #2eb85c; }
          .signature-area { margin-top: 60px; display: flex; justify-content: space-around; }
          .signature-box { border-top: 1px solid #2f2f2f; width: 280px; padding-top: 8px; font-size: 11px; text-align: center; }
          .report-footer { position: fixed; left: 16px; right: 16px; bottom: 8px; display: flex; justify-content: space-between; font-size: 10px; border-top: 1px solid #2f2f2f; padding-top: 4px; background: #fff; }
          @media print { @page { size: A4 portrait; margin: 12mm; } body { margin: 0; } }
        </style>
      </head>
      <body>
        <div class="report-header">
          <div class="report-header-top">
            <div><strong>${escapeHtml(empresa.FANTASIA || empresa.RAZAO_RELATORIO || empresa.RAZAO || 'CECWEB')}</strong></div>
            <div><strong>Usuário:</strong> ${escapeHtml(nomeUsuario)}</div>
          </div>
          <div class="report-header-title text-center">Ficha de Identificação de Lote</div>
          <div class="report-header-sub">
            <div>${escapeHtml(empresa.NOME_EMPRESA || '')}</div>
            <div><strong>Emitido em:</strong> ${escapeHtml(formatarDataHoraRelatorio())}</div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">Dados do Produto e Lote</div>
          <table class="info-table">
            <tr>
              <td>
                <span class="val-label">Produto</span>
                <span class="val-content">${escapeHtml(lote.DESCRICAO_PRODUTO)}</span>
              </td>
              <td>
                <span class="val-label">Identificação do Lote</span>
                <span class="val-content" style="font-size: 20px;">${escapeHtml(lote.LOTE)}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="val-label">Centro de Estoque</span>
                <span class="val-content">${escapeHtml(lote.DESCRICAO_CENTRO)}</span>
              </td>
              <td>
                <span class="val-label">Unidade Comercial</span>
                <span class="val-content">${escapeHtml(lote.ID_UNIDADE_COMERCIAL || 'UN')}</span>
              </td>
            </tr>
          </table>
        </div>

        <div class="section">
          <div class="section-title">Controle de Validade e Saldo</div>
          <table class="info-table">
            <tr>
              <td>
                <span class="val-label">Data de Validade</span>
                <span class="val-content">${escapeHtml(this.formatarData(lote.DATA_VALIDADE))}</span>
              </td>
              <td>
                <span class="val-label">Saldo Atual em Estoque</span>
                <span class="val-content" style="color: #2c3e50;">${escapeHtml(this.formatarNumero(lote.QUANT_SALDO, 2))}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="val-label">Dias Restantes</span>
                <span class="val-content">${escapeHtml(lote.DIAS_PARA_VENCER)} dias</span>
              </td>
              <td>
                <span class="val-label">Situação Atual</span>
                <div class="status-badge bg-${this.statusColor(lote.STATUS_VALIDADE)}">
                  ${escapeHtml(lote.STATUS_VALIDADE)}
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div class="section" style="margin-top: 40px;">
          <div class="section-title">Observações de Movimentação</div>
          <div style="border: 1px solid #eee; height: 120px; padding: 10px; font-size: 11px; color: #999;">
            Espaço reservado para anotações manuais de conferência e movimentação física do lote.
          </div>
        </div>

        <div class="signature-area">
          <div class="signature-box">Responsável pelo Almoxarifado</div>
          <div class="signature-box">Controle de Qualidade</div>
        </div>

        <div class="report-footer">
          <div>Identificador de Lote: ${escapeHtml(lote.LOTE)}</div>
          <div>Impresso por: ${escapeHtml(nomeUsuario)}</div>
          <div>Página 1 de 1</div>
        </div>
      </body>
      </html>`
    }
  }
}
</script>

<style scoped>
.page-col {
  padding: 1.5rem;
  background-color: #f8fafc;
  min-height: 100vh;
}

.bg-primary-soft { background-color: rgba(102, 126, 234, 0.1); }
.bg-white-10 { background-color: rgba(255, 255, 255, 0.2); }
.bg-black-10 { background-color: rgba(0, 0, 0, 0.1); }

.bg-danger-soft-row { background-color: rgba(229, 83, 83, 0.05) !important; }
.bg-warning-soft-row { background-color: rgba(249, 177, 21, 0.05) !important; }

.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.chart-container {
  position: relative;
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.infinite {
  animation-iteration-count: infinite;
}

@keyframes pulse {
  from { transform: scale3d(1, 1, 1); }
  50% { transform: scale3d(1.05, 1.05, 1.05); }
  to { transform: scale3d(1, 1, 1); }
}

.pulse {
  animation-name: pulse;
}

.table-card-rows ::v-deep tr {
  transition: all 0.2s ease;
}

.table-card-rows ::v-deep tr:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
</style>



// WEBPACK FOOTER //
// src/views/estoque/EstoqueValidadeLotes.vue